import { Route } from '@angular/router';
import { CallbackComponent } from '@thiememeulenhoff/ng-security';
import { adminAccessGuard } from '../_guards/admin-access.guard';

const routes: Array<Route> = [
  {
    path: 'forbidden',
    loadComponent: () =>
      import('../_components/admin-forbidden/admin-forbidden.component').then(
        (module) => module.AdminForbiddenComponent,
      ),
  },
  {
    path: 'readers',
    data: { showBreadcrumbs: false },
    loadComponent: () =>
      import('../_components/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [adminAccessGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../features/admin-readers/admin-readers.component').then(
            (module) => module.AdminReadersComponent,
          ),
      },
      {
        path: ':readerId',
        loadComponent: () =>
          import('../features/admin-readers/admin-reader-detail/admin-reader-detail.component').then(
            (module) => module.AdminReaderDetailComponent,
          ),
      },
    ],
  },
  {
    path: 'methods',
    data: { showBreadcrumbs: false },
    loadComponent: () =>
      import('../_components/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [adminAccessGuard],
    children: [
      {
        path: '',

        loadComponent: () =>
          import('../features/admin-methods/admin-methods.component').then(
            (module) => module.AdminMethodsComponent,
          ),
      },
    ],
  },
  {
    path: 'arrangements',
    data: { showBreadcrumbs: false },
    loadComponent: () =>
      import('../_components/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [adminAccessGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../features/admin-arrangements/admin-arrangements.component').then(
            (module) => module.AdminArrangementsComponent,
          ),
      },
    ],
  },
  {
    path: '',
    data: { showBreadcrumbs: true },
    loadComponent: () =>
      import('../_components/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [adminAccessGuard],
    children: [
      {
        path: 'user',
        loadChildren: () =>
          import('../features/admin-user/admin-user.routes').then(
            (module) => module.adminUserRoutes,
          ),
      },
      {
        path: 'oauth/callback',
        component: CallbackComponent,
      },
      {
        path: '**',
        loadComponent: () =>
          import('../features/admin-user/admin-user.component').then(
            (module) => module.AdminUserComponent,
          ),
      },
    ],
  },
];

export default routes;
